import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps } from "vue"

interface IEmits {
  (event: 'update:modelValue', data: number | string): void
}

interface IProps {
  modelValue: string | number
  tabPanelClass?: string
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KTabPanel' },
  __name: 'KTabPanel',
  props: {
    modelValue: {},
    tabPanelClass: { default: '' }
  },
  emits: ["update:modelValue"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!

  return (_openBlock(), _createBlock(_component_q_tab_panels, _mergeProps({
    "model-value": __props.modelValue,
    animated: ""
  }, _ctx.$attrs, {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
  }), {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.$slots), (slot, index) => {
        return (_openBlock(), _createBlock(_component_q_tab_panel, {
          key: index,
          name: slot,
          class: _normalizeClass(__props.tabPanelClass)
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, slot)
          ]),
          _: 2
        }, 1032, ["name", "class"]))
      }), 128))
    ]),
    _: 3
  }, 16, ["model-value"]))
}
}

})